<template>
  <div class="sidebar-section">
    <div class="sidebar-wrapper">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppSidebar",
  props: ['lessonDetail']
}
</script>

<style lang="scss" scoped>
.sidebar-section {
  background-color: #024089;
  height: 100%;
  width: 100%;

  .sidebar-wrapper {
    height: 100%;
    width: 340px;
    padding: 42px 26px;

  }
}
</style>
